import { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useEnv } from "../../context/EnvContext";
import "./Header.css";

function Header() {
  const navigate = useNavigate();
  const { env } = useEnv() || {};

  // Auth config
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const activeAccount = instance.getActiveAccount();
  const roles = activeAccount?.idTokenClaims.roles || [];
  const isAdmin = roles.includes("LLMaaS_Admin");

  useEffect(() => {
    if (!env) {
      console.warn("Environment not set");
      return;
    }

    console.log("Current environment: ", env);
  }, [env]);

  const handleNavigation = (path) => {
    console.log("Navigating to:", path);
    window.location.href = path;
  };

  return (
    <>
      <header className="header-container">
        <span style={{ width: "100%", display: "flex" }}>
          <a href="/" className="header-gm-logo">
            <img
              src="/resources/gm-logo-long.png"
              alt="GM Logo"
              style={{ height: "21px", width: "166px" }}
            />
          </a>
        </span>
        <nav className="blue-gm-navbar">
          <div className="nav-list-container">
            <ul role="menubar" className="navbar-parent-list nav-list">
              <ul className="left-nav-list nav-list">
                <li className="m-0">
                  <div
                    role="menuitem"
                    tabIndex="0"
                    onClick={() => navigate("/")}
                    className="navbar-list-title navbar-list-text nav-list-item"
                  >
                    <span>LLMaaS Operations Portal</span>
                  </div>
                </li>
                {isAuthenticated && isAdmin ? (
                  <>
                    {/* Infrastructure Dropdown */}
                    <Dropdown
                      className="navbar-list-text nav-list-item"
                      id="dropdown-infrastructure"
                    >
                      <Dropdown.Toggle
                        className="dropdown-toggle navbar-list-text nav-list-item"
                        id="dropdown-button-infrastructure"
                        variant="flat"
                      >
                        Infrastructure
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-links">
                        <Dropdown.Item
                          className="dropdown-link"
                          onClick={() => {
                            handleNavigation("/milford-aidc");
                          }}
                        >
                          MIL Cluster
                        </Dropdown.Item>
                        {env === "prod" && (
                          <Dropdown.Item
                            className="dropdown-link"
                            onClick={() => {
                              handleNavigation("/warren-aidc");
                            }}
                          >
                            WRN Cluster
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                    {/* Metrics direct link */}
                    <li className="m-0">
                      <div
                        role="menuitem"
                        tabIndex="0"
                        onClick={() => navigate("/metrics")} 
                        className="navbar-list-text nav-list-item"
                      >
                        <span>Metrics</span>
                      </div>
                    </li>
                    <li className="m-0">
                      <div
                        role="menuitem"
                        tabIndex="0"
                        onClick={() => navigate("/self-registration")}
                        className="navbar-list-text nav-list-item"
                      >
                        <span>Self Registration</span>
                      </div>
                    </li>
                  </>
                ) : null}
              </ul>
              {/* <ul className="right-nav-list nav-list">
                  <li className="m-0">
                    <div className="navbar-list-text nav-list-item">
                      <input
                        type="text"
                        placeholder="Search..."
                        className="search-input"
                      />
                    </div>
                  </li>
                  <li className="m-0">
                    <div className="navbar-list-text nav-list-item">
                        <ToggleSwitch />
                    </div>
                </li>
                </ul> */}
            </ul>
          </div>
        </nav>
      </header>
    </>
  );
}

export default Header;
